import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames'

import UserStatusModalContainer from '../../../../containers/pages/service/UserStatus.modal.container.jsx';
import Header from '../../../../components/controls/header/Header.jsx';
import DetailsLinks from '../../../custom/details/DetailsLinks.jsx';
import Details from '../../../custom/details/Details.jsx';
import Image from '../../../controls/image/Image.jsx';
import StatusSelector from '../../../controls/statusSelector/StatusSelector.jsx';
import ProgressBar from '../../../controls/progressBar/ProgressBar.jsx';

import { composeCircleProgress } from 'pluton-charts/lib/charts/home/CircleProgress';
import { VictoryPie } from "victory";
const CircleProgress = composeCircleProgress({
    Svg: 'svg',
    VictoryPie
});

import { routes } from 'pluton-core/lib/constants/routes.constant';
import { history } from '../../../../entry/history';

import {
    getCircleProgressCurrentValue,
    getCircleProgressRotateSpeed
} from 'pluton-core/lib/services/core/home/home.helper';
import {
    IMAGE_LOGO,
    ICON_SETTING,
} from 'pluton-core/lib/constants/image.constant';


class HomePage extends Component {

    handleGoToUtilitySettings = () => {
        history.push(routes.utilitySettings())
    };

    renderWeather = () => {
        if (!this.props.weatherData || this.props.weatherData.weatherStatus.isError) {
            return null;
        }

        const Icon = this.props.weatherData.weatherStatus.icon;
        return (
            <div className="weather-status">
                <div className="weather-status__icon">{Icon && <Icon fill={'#0080c5'}/>}</div>
                <div className="weather-status__meaning">
                    <span className="weather-status__meaning-number">
                        {this.props.weatherData.weatherStatus.temperature}
                    </span>
                    <span className="weather-status__meaning-text">
                        &#x2103;
                    </span>
                    </div>
                <div className="weather-status__meaning">
                    <span className="weather-status__meaning-number">
                        {this.props.weatherData.weatherStatus.humidity}
                    </span>
                    <span className="weather-status__meaning-text">
                        %RH
                    </span>
                </div>
                <div className="weather-status__meaning">
                    <span className="weather-status__meaning-number">
                        {this.props.weatherData.weatherStatus.pressure}
                    </span>
                    <span className="weather-status__meaning-text">
                        hPa
                    </span>
                </div>
            </div>
        );
    };

    renderChart = () => {
        const {
            details: {
                isLoading
            },
            isErrors
        } = this.props;

        const classNamesObj = classNames({
            'house__img': true,
            'house__img--access': isLoading && !isErrors,
            'house__img--access house__img--avoid': !isLoading && !isErrors,
            'house__img--error house__img--avoid': !isLoading && isErrors,
        });

        const currentValue = getCircleProgressCurrentValue(this.props.controlsData.power.value, this.props.controlsData.powerLimits.maxOverload);
        const speed = getCircleProgressRotateSpeed(currentValue, this.props.controlsData.powerLimits.maxOverload);

        const chartClassNamesObj = classNames({
            'home-progress__chart': true,
            [`home-progress__is-rotate_${speed}`]: !this.props.controlsData.oldData.isOldData,
        });

        return (
            <div className="home-progress">
                <div className={chartClassNamesObj}>
                    <CircleProgress
                        animateDuration={speed}
                        currentValue={currentValue / 1000}
                        maxValue={this.props.controlsData.powerLimits.maxOverload / 1000}
                        highValue={this.props.controlsData.powerLimits.maxPower / 1000}
                    />
                </div>
                {this.renderWeather()}
                <div className="home-progress__img page__img">
                    <div className={classNamesObj}/>
                </div>
            </div>
        )
    };

    renderHeader = () => {
        return (
            <Header headerTitle='My Home'>
                <div className="header__logo header__logo--left">
                    <Image
                        src={ IMAGE_LOGO }
                        className="header__icon"
                        imgClassName="icon icon--header"
                    />
                </div>
                <Link className="header__link header__link--right" to={`${routes.settings()}`}>
                    <Image
                        src={ ICON_SETTING }
                        className="header__icon header__icon--right"
                        imgClassName="icon icon--header"
                    />
                </Link>
            </Header>
        );
    };

    renderStatus = () => {
        return (
            <div className="page__status" onClick={this.props.handleToggleModal.bind(null, UserStatusModalContainer)}>
                {this.props.homeData.homeStatus.text}
            </div>
        );
    };

    renderSpinner = () => {
        const {
            details: {
                isLoading
            },
            isErrors
        } = this.props;

        const classNamesObj = classNames({
            'house__img': true,
            'house__img--access': isLoading && !isErrors,
            'house__img--access house__img--avoid': !isLoading && !isErrors,
            'house__img--error house__img--avoid': !isLoading && isErrors,
        });

        return (
            <div className="page__img page__img--home">
                <div className={classNamesObj}/>
            </div>
        );
    };

    renderLabel = () => {
        return (
            <div className="page__label"
                 onClick={this.handleGoToUtilitySettings}>
                My Utility
            </div>
        );
    };

    renderDetailsLoading = () => {
        return (
            <div className="alert alert--single">
                <div className="alert__header alert__header--single">
                    <div className="alert__title">
                    </div>
                </div>
            </div>
        );
    };

    renderDetails = () => {
        if (this.props.isErrors) {
            return (
                <Details {...this.props} />
            );
        }

        return (
            <DetailsLinks {...this.props} />
        );
    };

    renderButton = () => {
        if (this.props.isAuth) {
            return null;
        }

        return (
            <div className="btn-wrap btn-wrap--connect">
                <Link to={routes.login()} className="btn btn--prime">
                    Sign in
                </Link>
            </div>
        );
    };

    renderLoading = () => {
        if (this.props.homeData.setHomeStatus.isLoading) {
            return (
                <ProgressBar/>
            );
        }

        return null;
    };

    render() {
        const classNamesObj = classNames({
            'page': true,
            'page--error': this.props.isErrors
        });

        return (
            <div className="app-container">
                <div className={classNamesObj}>
                    {this.renderLoading()}
                    {this.renderHeader()}
                    <div className="page__content page__content--connect">
                        {this.renderStatus()}
                        {this.renderChart()}
                        {this.renderLabel()}
                        {this.renderDetailsLoading()}
                        {this.renderDetails()}
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
}


HomePage.propTypes = {
    isAuth: PropTypes.bool,
    isErrors: PropTypes.bool,
    settings: PropTypes.object,
    details: PropTypes.object,

    alertsToggled: PropTypes.array,
    handleAlertsToggle: PropTypes.func,
    handleSetAlertToJump: PropTypes.func,
};

export default HomePage;



// WEBPACK FOOTER //
// ./app/components/pages/core/home/Home.page.jsx